class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.setAttribute('aria-expanded', 'false');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.classList.contains('active') ? this.close() : this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.classList.contains('active') ? this.close() : this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // Remember menu state, then collapse it — only one panel at a time
    const header = document.querySelector('.header');
    this._menuWasOpen = !!(header && header.classList.contains('header-menu-open'));
    if (this._menuWasOpen) {
      header.classList.remove('header-menu-open');
      document.body.classList.remove('overflow-hidden');
      const filterDrawer = document.querySelector('filter-drawer');
      if (filterDrawer) filterDrawer.classList.remove('active');
      // Sync the filter button label — menu is now collapsed
      const filterLabel = document.querySelector('#filter-icon-bubble .filter-button-text');
      if (filterLabel) filterLabel.textContent = 'Menu';
      const filterBtn = document.querySelector('#filter-icon-bubble');
      if (filterBtn) filterBtn.setAttribute('aria-expanded', 'false');
    }

    this.updateButtonText('Close');
    document.querySelector('#cart-icon-bubble')?.setAttribute('aria-expanded', 'true');
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
      document.body.classList.add('cart-drawer-active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    document.body.classList.remove('cart-drawer-active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
    this.updateButtonText('Cart');
    document.querySelector('#cart-icon-bubble')?.setAttribute('aria-expanded', 'false');

    // Restore the menu if it was open before the cart opened
    if (this._menuWasOpen) {
      this._menuWasOpen = false;
      const header = document.querySelector('.header');
      if (header) {
        header.classList.add('header-menu-open');
        const filterLabel = document.querySelector('#filter-icon-bubble .filter-button-text');
        if (filterLabel) filterLabel.textContent = 'Close';
        const filterBtn = document.querySelector('#filter-icon-bubble');
        if (filterBtn) filterBtn.setAttribute('aria-expanded', 'true');
        // sessionStorage is untouched — it was never cleared, so persistence is intact
      }
    }
  }

  updateButtonText(text) {
    const span = document.querySelector('#cart-icon-bubble .cart-button-text');
    if (span) span.textContent = text;
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement) return;
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
      this.updateButtonText('Close');
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);
